module.exports = __webpack_public_path__ + "img/icon-support.4981581f.svg";